var indentation_default = {
  "indentZero": "c8Tjw",
  "indentOne": "NnMgd",
  "indentTwo": "isFUB",
  "indentThree": "psyAh",
  "indentFour": "n3oHG",
  "indentFive": "qzJkT",
  "indentSix": "_6gaV4"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
